import clsx from "clsx";
import { useLocation, useNavigate } from "react-router";
import { SuggestAuth } from "../SuggestAuth/SuggestAuth";
import s from "./style.module.scss";
import { userAtom } from "@/core/reatom/state/user/user";
import { useAtom } from "@reatom/npm-react";
import Person from "@/assets/person.svg?react";
import Cube from "@/assets/cube.svg?react";

export const Epic = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [user] = useAtom(userAtom);
  return (
    <>
      <div
        className={s.epic}
        data-will-show-suggestion={
          !(pathname === "/profile" || pathname === "/checkout")
        }
      >
        {/* 
          // TODO Заменить `isAuthed` на итоговый источник состояния авторизации
        */}
        {/* {!user && (pathname === "/profile" || pathname === "/checkout") && (
          <SuggestAuth />
        )} */}
        <div className={s.epic_menu}>
          <button
            className={clsx(s.button, pathname === "/" && s.active)}
            onClick={() => navigate("/")}
          >
            <div className={clsx(s.stroke, pathname === "/" && s.activeStroke)}>
              <Cube width={23.64} height={23.64} />
            </div>
            Услуги
          </button>
          <button
            id="profilemob"
            className={clsx(s.button, pathname === "/profile" && s.active)}
            onClick={() => navigate("/profile")}
          >
            <div
              className={clsx(
                s.stroke,
                pathname === "/profile" && s.activeStroke
              )}
            >
              <Person />
            </div>
            Профиль
          </button>
        </div>
      </div>
    </>
  );
};
